module.exports = __webpack_public_path__ + "img/store-icon.4997f4e7.jpg";